const VALID_AREAS = {
    acre: "acre",
    squarekilometer: "squarekilometer",
    squaremetre: "squaremetre",
    squaremile: "squaremile",
    squareyard: "squareyard",
    squarefoot: "squarefoot",
    squareinch: "squareinch",
    hectare: "hectare"
};

const WEIGHTS_LIST = [
    { label: "Metric Tonne", value: "metric tonne" },
    { label: "Short Ton", value: "short ton" },
    { label: "Kilogram", value: "kilogram" },
    { label: "Pound", value: "pound" },
    { label: "Bushel 60 lb", value: "bushel 60 lb" },
    { label: "Bushel 56 lb", value: "bushel 56 lb" },
    { label: "Bushel 48 lb", value: "bushel 48 lb" },
    { label: "Bushel 34 lb", value: "bushel 34 lb" },
    { label: "Bushel 32 lb", value: "bushel 32 lb" },
    //    { label: "Short Hundredweight", value: "short hundredweight" },
    //    { label: "Long Hundredweight", value: "long hundredweight" },
    { label: "Grams", value: "grams" }
];

const MAP_OPTIONS = {
    accessToken: "pk.eyJ1IjoibWFsaWtmb3V6ZSIsImEiOiJjanF6ZHU2ZHowZDF1NDNsazl6dWF2OXoxIn0.7ZmKrMF5juUPgm2QS6RpsQ",
    //style: "mapbox://styles/malikfouze/cjsos1ccq219e1gkbdn64hk9p",//streets
    style: "mapbox://styles/malikfouze/cjsoryqsn0ck51fqvt858coqp", //black
    //style: "mapbox://styles/malikfouze/cjqzfa3r72dku2sljvm9d0sks", //sat
    //center: [-106.39640808105469, 52.276245566098574],
    center: [-106.657807, 52.136847], //Sunrise building
    zoom: 13
};

const initialState = {
    WEIGHT_UNIT: WEIGHTS_LIST[0],
    AREA_UNIT: "acre",
    progressbarPercentage: 10,
    WEIGHTS_LIST: WEIGHTS_LIST,
    MAP_OPTIONS: MAP_OPTIONS
};

const state = JSON.parse(JSON.stringify(initialState));

const actions = {};

const mutations = {
    setProgressBarPercentage(state, payload) {
        var percentage = 0;
        percentage = payload.percentage;

        try {
            //If the percentages given are crap values set this thing to 0
            if (!payload.percentage || payload.percentage > 100 || payload.percentage < 0) {
                percentage = 0;
            }

            state.progressbarPercentage = percentage;
        } catch (e) {
            //eslint-disable-next-line
            console.log(e.message);
        }
    },
    resetState(state) {
        state.WEIGHT_UNIT = initialState.WEIGHT_UNIT;
        state.AREA_UNIT = initialState.AREA_UNIT;
    },
    setGlobalWeightUnit(state, payload) {
        if (!payload.value) {
            state.WEIGHT_UNIT = WEIGHTS_LIST[0]; //what ever is in the 0th index we set as default
            return;
        }
        state.WEIGHT_UNIT = payload;
    },
    setGlobalAreaUnit(state, payload) {
        if (!VALID_AREAS[payload.value]) {
            state.AREA_UNIT = VALID_AREAS[0]; //what ever is in the 0th index we set as default
            return;
        }
        state.AREA_UNIT = VALID_AREAS[payload.value];
    }
};
const getters = {
    weightUnit() {
        return state.AREA_UNIT;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
